var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"copyright"},[_c('p',[_vm._v(_vm._s(_vm.currentYear)+" © Mytelnet (Pty) Ltd - ALL Right Reserved")])])
}
var staticRenderFns = []

export { render, staticRenderFns }